/* src/app/authorizenet-checkout/authorizenet-checkout-presenter/authorizenet-checkout-presenter.component.scss */
.admin-license-summary {
  row-gap: 1rem;
}
.admin-license-stepper .p-inputtext {
  text-align: center;
}
body#themeTag :host ::ng-deep .p-panel .p-panel-header {
  padding: 0 !important;
}
body#themeTag :host ::ng-deep .flex-column > * {
  padding: 0 !important;
}
body#themeTag :host ::ng-deep .flex-column {
  height: 85% !important;
}
body#themeTag :host ::ng-deep div.p-button.p-component.p-button-icon-only {
  background-color: white !important;
}
/*# sourceMappingURL=authorizenet-checkout-presenter.component.css.map */
